import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, HeartIcon, MoonIcon, LeafIcon, SparklesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const supports = [{
  icon: HeartIcon,
  title: 'Simplifica tu día a día',
  body: 'Recursos prácticos para que aplicar hábitos saludables sea sencillo, incluso con una vida ocupada. Listas, planificadores y guías paso a paso.'
}, {
  icon: SparklesIcon,
  title: 'Pensado para tu vida real',
  body: 'Cenas, viajes, momentos sociales. Aprendes a integrar tu bienestar sin renunciar a los momentos que disfrutas con quienes amas.'
}, {
  icon: LeafIcon,
  title: 'Acompaña esta etapa de vida',
  body: 'No es un programa de "antes y después". Es un conjunto de recursos para apoyar tu bienestar femenino de una forma consciente y sostenida.'
}];
const offerItems = [{
  label: 'GUÍA PRINCIPAL',
  title: 'Código Hormonal 40+',
  description: 'Guía principal paso a paso. Una hoja de ruta clara para ayudarte a crear hábitos diarios que apoyen tu bienestar y equilibrio en esta etapa de vida.',
  value: 99,
  image: 'https://cdn.magicpatterns.com/uploads/iArNNoNqp5DLRGFBvjK2yR/La_mayoria_llega_sin_esto…_(3).png'
}, {
  label: 'INCLUYE',
  title: 'Protocolos de Descanso y Bienestar',
  description: 'Estrategias suaves y prácticas para apoyar un descanso reparador y tu equilibrio nocturno — sin pastillas, sin métodos extremos.',
  value: 77,
  image: 'https://cdn.magicpatterns.com/uploads/fVC8HJ8M9H6Ha2kPtGQ1Xk/Imagen_del_bono1.1.png'
}, {
  label: 'INCLUYE',
  title: 'Estrategias Prácticas de Alimentación',
  description: 'Cómo integrar tu vida social y momentos importantes manteniendo una relación amable con tu cuerpo. Sin culpa, sin restricciones imposibles.',
  value: 67,
  image: 'https://cdn.magicpatterns.com/uploads/gE679XNdsV2Hkjrdsm6vD9/Imagen_del_Bono2.png'
}, {
  label: 'INCLUYE',
  title: 'Recursos para Hábitos Sostenibles',
  description: 'Información clara sobre nutrientes y cuidados específicos para mujeres 40+, para que tomes decisiones informadas sobre tu bienestar.',
  value: 47,
  image: 'https://cdn.magicpatterns.com/uploads/5HTFZH4WrUuiAFxrJ1hQTC/Imagen_del_bono_3.png'
}];
export function Offer() {
  return <section className="bg-forest py-20 md:py-32" data-id="element-183">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-185">
          <p className="text-center text-xs md:text-sm font-bold tracking-[0.2em] text-gold-light uppercase mb-4" data-id="element-186">
            Lo que vas a recibir
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-6 text-center leading-tight" data-id="element-187">
            Todo lo que incluye{' '}
            <span className="italic text-gold-light" data-id="element-188">Código Hormonal 40+</span>
          </h2>
          <p className="text-lg md:text-xl text-warm-white/90 text-center mb-16 max-w-2xl mx-auto leading-relaxed" data-id="element-189">
            Una guía diseñada para ayudarte a crear hábitos más alineados con
            esta etapa de vida, apoyando bienestar, energía y equilibrio diario.
          </p>

          <div className="space-y-6 md:space-y-8 mb-12 md:mb-16" data-id="element-190">
            {offerItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.12,
            ease: 'easeOut'
          }} whileHover={{
            y: -6,
            transition: {
              duration: 0.3,
              ease: 'easeOut'
            }
          }} className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 p-5 md:p-7 bg-warm-white rounded-2xl shadow-[0_25px_50px_-12px_rgba(0,0,0,0.35),0_15px_30px_-10px_rgba(0,0,0,0.25)] border border-white/20" data-id="element-191">
                {item.image ? <div className="flex-shrink-0 w-full sm:w-32 md:w-40 aspect-[3/4] bg-cream rounded-lg overflow-hidden" data-id="element-192">
                    <img src={item.image} alt={`Portada de ${item.title}`} width={400} height={533} loading="lazy" decoding="async" className="w-full h-full rounded-lg shadow-md object-cover" data-id="element-193" />
                  </div> : <div className="flex-shrink-0 w-full sm:w-32 md:w-40 aspect-[3/4] bg-forest rounded-lg shadow-md flex items-center justify-center p-4" data-id="element-194">
                    <div className="text-center" data-id="element-195">
                      <div className="font-serif text-gold-light text-2xl md:text-3xl font-bold leading-tight" data-id="element-196">
                        CÓDIGO HORMONAL
                      </div>
                      <div className="text-gold-light font-serif text-xl md:text-2xl font-bold mt-1" data-id="element-197">
                        40+
                      </div>
                    </div>
                  </div>}

                <div className="flex-1 w-full" data-id="element-198">
                  <div className="flex items-center gap-2 mb-2" data-id="element-199">
                    <span className="text-[10px] md:text-xs font-bold tracking-[0.15em] text-gold bg-gold/10 px-2 py-1 rounded" data-id="element-200">
                      {item.label}
                    </span>
                    <CheckIcon className="w-4 h-4 text-forest flex-shrink-0" data-id="element-201" />
                  </div>
                  <h3 className="text-lg md:text-xl lg:text-2xl font-serif font-semibold text-charcoal mb-2 leading-tight" data-id="element-202">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/70 text-sm md:text-base mb-3 leading-relaxed" data-id="element-203">
                    {item.description}
                  </p>
                  <p className="text-charcoal/50 text-sm" data-id="element-204">
                    Valor: <span className="line-through" data-id="element-205">${item.value}</span>{' '}
                    <span className="text-forest font-semibold ml-1" data-id="element-206">
                      Incluido
                    </span>
                  </p>
                </div>
              </motion.div>)}
          </div>

          <div className="bg-warm-white rounded-lg p-8 md:p-12 shadow-2xl" data-id="element-207">
            <div className="my-4 md:my-6" data-id="element-208">
              <div className="flex items-center justify-center gap-3 mb-6" data-id="element-209">
                <span className="h-px w-12 bg-gold" data-id="element-210"></span>
                <SparklesIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-211" />
                <span className="h-px w-12 bg-gold" data-id="element-212"></span>
              </div>

              <p className="text-center text-xs md:text-sm font-bold tracking-[0.2em] text-gold uppercase mb-3" data-id="element-213">
                Pensado para acompañarte
              </p>

              <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl text-charcoal text-center leading-tight mb-8" data-id="element-214">
                Una forma diferente de cuidarte
              </h3>

              <div className="space-y-5 text-charcoal/80 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-215">
                <p data-id="element-216">
                  La mayoría de los programas te dan información y te dejan
                  sola. En{' '}
                  <strong className="text-charcoal" data-id="element-217">Código Hormonal 40+</strong>
                  , cada recurso fue pensado para que sea sencillo de aplicar en
                  tu día a día real.
                </p>
                <p data-id="element-218">
                  La{' '}
                  <span className="font-serif text-charcoal font-semibold" data-id="element-219">
                    Dra. Elisabeth Mayo
                  </span>{' '}
                  ha diseñado este conjunto de recursos como un{' '}
                  <span className="text-gold font-semibold" data-id="element-220">
                    acompañamiento integral
                  </span>{' '}
                  para esta etapa de vida:
                </p>
              </div>

              <div className="space-y-5 mb-10" data-id="element-221">
                {supports.map((item, index) => {
                const Icon = item.icon;
                return <motion.div key={index} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: index * 0.1
                }} className="flex items-start gap-4 md:gap-5 p-5 md:p-6 bg-cream/60 rounded-xl border-l-4 border-gold" data-id="element-222">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-forest flex items-center justify-center" data-id="element-223">
                        <Icon className="w-6 h-6 text-gold-light" data-id="element-224" />
                      </div>
                      <div className="flex-1" data-id="element-225">
                        <h4 className="font-serif text-lg md:text-xl font-semibold text-charcoal mb-2 leading-tight" data-id="element-226">
                          {item.title}
                        </h4>
                        <p className="text-charcoal/75 text-sm md:text-base leading-relaxed" data-id="element-227">
                          {item.body}
                        </p>
                      </div>
                    </motion.div>;
              })}
              </div>

              <div className="bg-forest rounded-xl p-6 md:p-8 text-center" data-id="element-228">
                <p className="text-warm-white text-base md:text-lg leading-relaxed mb-3" data-id="element-229">
                  Al acceder a este conjunto de recursos hoy, no recibes solo un
                  libro digital. Recibes un{' '}
                  <strong className="text-gold-light" data-id="element-230">
                    acompañamiento completo
                  </strong>{' '}
                  para apoyar tu bienestar femenino, con materiales que puedes
                  consultar siempre que los necesites.
                </p>
                <p className="font-serif italic text-lg md:text-xl text-gold-light mt-4" data-id="element-231">
                  Es información, pero también es compañía en este camino.
                </p>
              </div>

              <div className="mt-8 bg-gold/10 border border-gold/30 rounded-xl p-6 md:p-7 text-center" data-id="element-232">
                <p className="text-charcoal text-base md:text-lg leading-relaxed" data-id="element-233">
                  Si sumaras el valor de cada uno de estos recursos por
                  separado, el costo superaría los{' '}
                  <span className="font-serif text-2xl md:text-3xl font-bold text-gold" data-id="element-234">
                    $223 USD
                  </span>
                  .
                </p>
                <p className="text-charcoal/80 text-sm md:text-base mt-3 leading-relaxed" data-id="element-235">
                  Hoy, la Dra. Mayo quiere ofrecerlos todos juntos como parte de
                  su misión de hacer este camino más accesible.
                </p>
              </div>
            </div>

            <div className="border-t-2 border-gold pt-8" data-id="element-236">
              <div className="flex justify-between items-center mb-4" data-id="element-237">
                <span className="text-lg md:text-xl text-charcoal/70 font-medium" data-id="element-238">
                  Valor de los recursos:
                </span>
                <span className="text-lg md:text-xl text-charcoal/40 line-through" data-id="element-239">
                  $223
                </span>
              </div>

              <div className="relative bg-forest rounded-lg p-6 md:p-8 mb-8 overflow-hidden" data-id="element-240">
                <div className="absolute -top-3 -right-3 bg-gold text-charcoal text-[10px] md:text-xs font-bold px-3 py-2 rounded-full shadow-lg rotate-3 max-w-[180px] text-center leading-tight" data-id="element-241">
                  ACCESO ESPECIAL
                </div>

                <p className="text-warm-white/90 text-sm md:text-base uppercase tracking-wider mb-2 font-semibold" data-id="element-242">
                  Acceso preferencial:
                </p>

                <div className="flex items-baseline gap-3 mb-3" data-id="element-243">
                  <span className="text-2xl md:text-3xl text-warm-white/70 font-serif" data-id="element-244">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl lg:text-8xl font-serif text-gold-light font-bold leading-none" data-id="element-245">
                    17
                  </span>
                </div>

                <p className="text-warm-white/90 text-sm md:text-base italic" data-id="element-246">
                  Acceso especial disponible por tiempo limitado
                </p>
              </div>

              <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-247">
                Descubrir el Método
                <ArrowRightIcon className="w-5 h-5" data-id="element-248" />
              </motion.a>

              <p className="text-center text-charcoal/60 text-xs md:text-sm mt-4" data-id="element-249">
                🔒 Pago seguro · Acceso inmediato · Garantía de 60 días
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}